import clsx from 'clsx';

import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import s from './BottomBarWrapper.module.css';

type BottomBarWrapperProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  sticky?: boolean;
};

const BottomBarWrapper: FC<BottomBarWrapperProps> = ({ className, sticky, ...props }) => (
  <div className={clsx(s.wrapper, sticky && s.sticky, className)} {...props} />
);

export { BottomBarWrapper };
